module.exports = __webpack_public_path__ + "img/page_02.0965edac.jpg";